import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute, Router } from '@angular/router';
import { Observable, of, forkJoin, empty } from 'rxjs';
import { catchError} from 'rxjs/operators';
import { StorageManagerService, CompanyContactService, OrderService } from '../../shared/services/index';
import { AuthenticationService } from '../services/authentication.service';
import { RefdataService } from '../services/refdata.service';
import { LLFormService } from '../services/ll-form.service';
import { ICompanyContactStatus } from '../models/index';



@Injectable()
export class LLFormResolverService implements Resolve<any> {

    revisionId: string;
    customerGuid: string;
    companiesStatus: ICompanyContactStatus = { activeFlag: 'A', isDraftMode: false };

    constructor(private llService: LLFormService, private companyService: CompanyContactService,
                private storageManagerService: StorageManagerService, private refService: RefdataService,
                private orderService: OrderService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        const revisionId = route.params.revisionId;

        const currentCustomerStr: string = this.storageManagerService.read('currentCustomer');
        if (currentCustomerStr) {
            const currentCustomer = typeof currentCustomerStr === 'object' ? currentCustomerStr : JSON.parse(currentCustomerStr);
                if (currentCustomer) {
                this.customerGuid = currentCustomer.customerGuid;
            }
        }
        const retVal = forkJoin([
            revisionId ? this.llService.getLLFormById(revisionId) : of(null),
            this.llService.getSSDPVocabularies(),
            this.llService.getLCompanyTypesByCustomerGuid(this.customerGuid),
            this.llService.getCosmeticProducts(),
            revisionId ? this.llService.getRevisionHistory(revisionId) : of(null),
            revisionId ? this.orderService.getBaselineSplData(revisionId) : of(null),
            this.companyService.getBusinessCategories(false),
            this.refService.getActiveIngredientsType()]
        )
        .pipe(catchError(err => of({ error: err })));

        return retVal;
    }
}
